import { render, staticRenderFns } from "./OSheetReceiptPaymentComp.vue?vue&type=template&id=0141eadf&"
import script from "./OSheetReceiptPaymentComp.vue?vue&type=script&lang=js&"
export * from "./OSheetReceiptPaymentComp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VDivider,VSpacer})
